import * as React from 'react';
import { TextArea } from '@app/src/components/TextArea';
import { Field } from '@app/src/components/Field';

export const RenderTextArea = ({
  label,
  portionWidth,
  maxLength,
  meta: { error, touched },
  input,
  ...rest
}) => {
  let isError = (error && touched) ? error : '';
  return(
    <Field label={label} portionWidth={portionWidth} errorMessage={isError}>
      <TextArea
        maxLength={maxLength}
        {...input}
        {...rest}
        error={!!isError}
      />
    </Field>
  );
}
